import {CloseIcon, InfoOutlineIcon} from '@sanity/icons'
import {Card, Flex, Text} from '@sanity/ui'
import Link from 'next/link'
import {useState} from 'react'

import {Button} from '../../primitives/button/Button'

export const DashboardBanner: React.FC<{dashboardEnabled: boolean; orgId: string}> = (props) => {
  const {dashboardEnabled, orgId} = props
  const [showDashboardBanner, setShowDashboardBanner] = useState(
    !Boolean(localStorage.getItem(`overview-dashboard-banner-seen-${orgId}`))
  )

  const onDismiss = () => {
    setShowDashboardBanner(false)
    localStorage.setItem(`overview-dashboard-banner-seen-${orgId}`, 'true')
  }

  if (!showDashboardBanner) return null

  return (
    <Card paddingY={4} paddingX={4} radius={3} border tone="primary">
      <Flex align={'flex-start'} gap={4}>
        <Text size={1}>
          <InfoOutlineIcon />
        </Text>
        <Text size={1}>
          <strong>
            {dashboardEnabled
              ? 'The new Sanity Dashboard has been enabled for your organization.'
              : 'The new Sanity Dashboard is now available for your organization'}{' '}
          </strong>
          {dashboardEnabled
            ? 'Studios now launch directly within your organization’s unified dashboard view.'
            : '— a new unified view of your organizations studios and applications.'}{' '}
          <span style={{textWrap: 'nowrap'}}>
            {dashboardEnabled ? (
              <Link target="_blank" href="/docs/dashboard?ref=manage-banner">
                Learn more
              </Link>
            ) : (
              <Link target="_blank" href={`/@${orgId}?ref=manage-banner`}>
                Preview Dashboard
              </Link>
            )}
          </span>
        </Text>

        <Flex flex={1} justify={'flex-end'}>
          <Button
            padding={0}
            tooltipProps={{content: 'Dismiss banner'}}
            icon={CloseIcon}
            mode="bleed"
            onClick={onDismiss}
            aria-label="Dismiss banner"
          />
        </Flex>
      </Flex>
    </Card>
  )
}
